<template>
	<v-card class="d-flex align-center justify-center flex-column w-100 fill-height">
		<img
			style="max-width: 70%;"
			src="/images/module-in-development.png"
			alt=""
		>
		<h2
			class="text-primary"
			style="position:absolute; left: 5%; bottom: 5%;"
		>
			{{ $t('Waiting for data') }}
		</h2>
	</v-card>
</template>
<script>
export default {
	name: 'ModuleInDevelopment',
}
</script>
